import { render, staticRenderFns } from "./common-file-upload.vue?vue&type=template&id=5fa55818&scoped=true"
import script from "./common-file-upload.vue?vue&type=script&lang=ts"
export * from "./common-file-upload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa55818",
  null
  
)

export default component.exports